import service from "@/utils/request";
import * as apiRequest from "@/api/Type";
import {ModifyProject, QueryProjectUser} from "@/api/Type";
const url = require("@/utils/data").url;

/**
 * 获取当前用户下的项目列表
 */
export const getNowUserProjectList = () => {
    return service({
        url: url + "/project/list",
        method: "post",
        isToken: true,
        contentType: 'application/json;charset=UTF-8'
    })
}

/**
 * 添加项目
 * @param data {apiRequest.AddProjectRequest}
 */
export const addProject = (data: apiRequest.AddProjectRequest) => {
    return service({
        url: url + "/project/add",
        method: "post",
        isToken: true,
        data,
        contentType: 'application/json;charset=UTF-8'
    })
}

/**
 * 修改项目
 * @param data {apiRequest.ModifyProject}
 */
export const modifyProject = (data: apiRequest.ModifyProject) => {
    return service({
        url: url + "/project/modify",
        method: "post",
        isToken: true,
        data,
        contentType: 'application/json;charset=UTF-8'
    })
}

/**
 * 删除项目
 * @param data {apiRequest.DelProject}
 */
export const delProject = (data: apiRequest.DelProject) => {
    return service({
        url: url + "/project/del",
        method: "post",
        isToken: true,
        data,
        contentType: 'application/json;charset=UTF-8'
    })
}

/**
 * 查询项目人员
 * @param data {apiRequest.QueryProjectUser}
 */
export const queryProjectUser = (data: apiRequest.QueryProjectUser) => {
    return service({
        url: url + "/project/query/user",
        method: "post",
        isToken: true,
        data,
        contentType: 'application/json;charset=UTF-8'
    })
}

/**
 * 添加项目人员
 * @param data {apiRequest.AddUserToProject}
 */
export const addUserToProject = (data: apiRequest.AddUserToProject) => {
    return service({
        url: url + "/project/add/user",
        method: "post",
        isToken: true,
        data,
        contentType: 'application/json;charset=UTF-8'
    })
}

/**
 * 移交项目
 * @param data {apiRequest.TransferProject}
 */
export const transferProject = (data: apiRequest.TransferProject) => {
    return service({
        url: url + "/project/transfer",
        method: "post",
        isToken: true,
        data,
        contentType: 'application/json;charset=UTF-8'
    })
}

/**
 * 获取所有项目
 */
export const getAllProject = () => {
    return service({
        url: url + "/project/all/list",
        method: "get",
        isToken: true,
        contentType: 'application/json;charset=UTF-8'
    })
}
